

export default {
    inserted(el) {
        if(!window.ResizeObserver) {
            el.style.hyphens = 'auto';
            return;
        }
        const observer = new ResizeObserver(() => {
            el.style.hyphens = 'none';
            if(el.scrollWidth > el.clientWidth) {
                el.style.hyphens = 'auto';
            }
        });
        observer.observe(el)
    }
}
